<script setup>
import { ref } from 'vue';
import LayoutFooter from '@/components/layout/layoutFooter.vue';
import layoutShell from '@/components/layout/layoutShell.vue';
import compGroupsTable from '@/components/hackwatch/groups/compGroupsTable.vue';
import compActorsStatsPanel from '@/components/hackwatch/groups/compActorsStatsPanel.vue';

const tableRef     = ref(null);
const tableFilters = ref({});
</script>
<template>
  <!-- Sidebar -->
  <layoutShell>
    <div class="layout-content-wrapper">
      <main class="content">
        <!-- Table first in source order → full width on top for small screens -->
        <div class="grid">
          <div class="col-12 xl:col-9">
            <compGroupsTable ref="tableRef" @filters-change="f => tableFilters = f" />
          </div>
          <div class="col-12 xl:col-3">
            <compActorsStatsPanel
              :active-filters="tableFilters"
              @filter="f => tableRef?.applyExternalFilter(f)"
            />
          </div>
        </div>
      </main>
    </div>
    <div class="layout-footer">
      <LayoutFooter />
    </div>
  </layoutShell>
</template>
